import React from 'react';
import '../styles/index.scss';
interface Props {
  guideline: string;
  purpose: string;
}

function PurposeAndGuideline({ guideline, purpose }: Props): JSX.Element {
  return (
    <div className="purpose-guideline-container">
      <div className="purpose-rows-container">
        <div className="purpose-guideline-row">
          <div className="purpose-guideline-box purpose-guideline-top-row">
            Purpose for Assessment
          </div>
          <div className="purpose-guideline-box purpose-guideline-top-row">
            Guidelines
          </div>
        </div>
        <div className="purpose-guideline-row">
          <div className="purpose-guideline-box">{purpose}</div>
          <div className="purpose-guideline-box">{guideline}</div>
        </div>
      </div>
    </div>
  );
}

export { PurposeAndGuideline };
